module.exports = __webpack_public_path__ + "static/media/Logo.74d58383.png";